// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3bd1f4{padding:.75em;background:var(--white);border-radius:.5em}.dark-theme ._3bd1f4{background:rgba(0,0,0,.1)}", ""]);
// Exports
exports.locals = {
	"panel": "_3bd1f4"
};
module.exports = exports;
